export default {
  C: "C",
  CSharp: "Cis",
  D: "D",
  DFlat: "Des",
  DSharp: "Dis",
  E: "E",
  EFlat: "Es",
  F: "F",
  FSharp: "Fis",
  G: "G",
  GFlat: "Ges",
  GSharp: "Gis",
  A: "A",
  AFlat: "As",
  ASharp: "Ais",
  B: "H",
  BFlat: "B",

  correctExcl: "Richtig!",
  wrongExcl: "Falsch!",

  ABORT: "RUNDE ABBRECHEN",

  lastRound: "Letzte Runde",
  score: "Punkte",
  accuracy: "Genauigkeit",
  correct: "richtig",
  wrong: "falsch",

  START: "START",
  settings: "Optionen",
  ROUND_LENGTH: "RUNDENLÄNGE",
  NOTE_INPUT: "NOTENEINGABE",
  CLEF: "NOTENSCHLÜSSEL",
  DIFFICULTY: "SCHWIERIGKEITSGRAD",
  ACCIDENTALS: "VORZEICHEN",
  LANGUAGE: "SPRACHE",
  twentySeconds: "20 s",
  oneMinute: "1 min",
  fiveMinutes: "5 min",
  infinite: "Unendlich",
  buttons: "Buttons",
  piano: "Klavier",
  trebleClef: "Violin",
  bassClef: "Bass",
  altoClef: "Alt",
  tenorClef: "Tenor",
  pianoClef: "Klavier",
  easy: "Leicht",
  normal: "Mittel",
  hard: "Schwer",
  none: "Keine",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ und ♭",
  SOUND: "SOUND",
  VIBRATION: "VIBRATION",
  DISPLAYCORRECTNOTE: "KORREKTE MUSIKNOTE ANZEIGEN",
  on: "An",
  off: "Aus",

  TIME: "ZEIT",
  CORRECT: "RICHTIG",
  ACCURACY: "GENAUIGKEIT",
  SCORE: "PUNKTE",

  record: "Rekord",
  history: "Historie",

  noMidiSupport: "Sorry, dein Gerät scheint MIDI nicht zu unterstützen.",
  noDeviceFound: "Kein Gerät gefunden. Bitte das MIDI-Gerät erneut verbinden.",
  playTheNote: "Spiele die Note auf deinem MIDI-Keyboard.",
  lastNotePlayed: "Zuletzt gespielte Note",
};



// WEBPACK FOOTER //
// ./src/resources/de.js